module.exports = "pegasus/assets/square-pinterest.png";